import * as React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import {NavLink} from "react-router-dom";
import Link from '@mui/material/Link';
import {useEffect} from "react";

export default function InfoLinkView(){
    return(
        <Box sx={{ flexGrow: 1 , m:2}}>
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <Link href="https://about.sparheel.com" underline="none" color={"inherit"}>
                        About
                    </Link>
                </Grid>
                <Grid item xs={4}>
                    <Link href="/settings" underline="none" color={"inherit"}>
                        Settings
                    </Link>
                </Grid>
                <Grid item xs={4}>
                    <Link href="#" underline="none" color={"inherit"}>
                        Support
                    </Link>
                </Grid>
                <Grid item xs={4}>
                    <Link href="#" underline="none" color={"inherit"}>
                        Docs
                    </Link>
                </Grid>
                <Grid item xs={4}>
                    <Link target={"_blank"} href="https://app.termly.io/document/terms-of-use-for-website/a07b4892-8df6-4a16-b501-26b28e9445f3" underline="none" color={"inherit"}>
                        Term
                    </Link>
                </Grid>
                <Grid item xs={4}>
                    <Link target={"_blank"} href="https://app.termly.io/document/privacy-policy/2e532523-7d81-45ff-9845-1104de831aaf" underline="none" color={"inherit"}>
                        Privacy
                    </Link>
                </Grid>
                <Grid justifyContent={"center"} item xs={12}>
                    &copy;2022 Sparheel
                </Grid>
            </Grid>
        </Box>
    )
}